import { formatDate } from './date';

export const TYPE_OF_DELIVERY_COMPLETED = 'typeOfDeliveryCompleted';
export const RECEIPT_STATUS_COMPLETELY_RECEIVED = 'Completely_x0020_Received';
export const RECEIPT_STATUS_EXCESS_RECEIVED = 'Excess_x0020_Received';
export const DELIVERY_COMPLETED_FILTER = `${TYPE_OF_DELIVERY_COMPLETED} eq false and receiptStatusBETT ne '${RECEIPT_STATUS_COMPLETELY_RECEIVED}' and receiptStatusBETT ne '${RECEIPT_STATUS_EXCESS_RECEIVED}'`;

const getVendorScopeFilter = (currentVendor) => {
  if (currentVendor.VendorType === 'Warehouse') {
    return [`whseVendorCode eq '${currentVendor.vendNo}'`];
  }
  return ['vendConfirmationSent eq true', `vendorNo eq '${currentVendor.vendNo}'`];
};

// Single source of truth for the current-vendor-scoped Purchase Orders $filter.
// The list page (see src/pages/Dashboard/orders/purchase/index.jsx) calls this
// with its current dateRange/vendorPortalStatus state; the dashboard calls it
// with no options, which is by definition the list page's default view - see
// purchaseOrderFilters.verify.test.js.
export const buildPurchaseOrdersFilter = (
  currentVendor,
  { dateRange = null, vendorPortalStatus = 'ALL' } = {}
) => {
  const filter = [DELIVERY_COMPLETED_FILTER];
  if (dateRange !== null) {
    const startDate = formatDate(dateRange[0]);
    const endDate = formatDate(dateRange[1]);
    filter.push(`expectedReceiptDate gt ${startDate} and expectedReceiptDate lt ${endDate}`);
  }
  filter.push(...getVendorScopeFilter(currentVendor));
  if (vendorPortalStatus !== 'ALL') {
    filter.push(`vendorPortalStatus eq '${vendorPortalStatus}'`);
  }
  return filter.join(' and ');
};
